(function () {
  'use strict';

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function slugify(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function countWords(text) {
    return String(text || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean).length;
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function getContentBlocks(body) {
    var nested = body.querySelector('.tcb-article.rte, .rte');
    if (nested && nested !== body && nested.children.length) {
      return Array.prototype.slice.call(nested.children);
    }
    if (body.children.length) {
      return Array.prototype.slice.call(body.children);
    }
    return [];
  }

  function resolvePreviewWords(wrap) {
    var minWords = parseInt(wrap.getAttribute('data-tcb-bf-readmore-min-words') || '150', 10);
    var maxWords = parseInt(wrap.getAttribute('data-tcb-bf-readmore-max-words') || '300', 10);
    var targetWords = parseInt(wrap.getAttribute('data-tcb-bf-readmore-target-words') || '200', 10);

    minWords = Math.max(150, minWords || 150);
    maxWords = Math.max(minWords, maxWords || 300);
    targetWords = Math.min(maxWords, Math.max(minWords, targetWords || 200));

    return targetWords;
  }

  function previewMetrics(body, targetWords) {
    var blocks = getContentBlocks(body);
    if (!blocks.length) {
      return { height: body.scrollHeight, cutoff: null, words: countWords(body.innerText) };
    }

    var totalWords = countWords(body.innerText);
    if (totalWords <= targetWords) {
      return { height: body.scrollHeight, cutoff: blocks[blocks.length - 1], words: totalWords };
    }

    var words = 0;
    var cutoff = blocks[blocks.length - 1];
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      if (block.tagName === 'H1') continue;
      words += countWords(block.innerText);
      cutoff = block;
      if (words >= targetWords) break;
    }

    var bodyRect = body.getBoundingClientRect();
    var cutRect = cutoff.getBoundingClientRect();
    return {
      height: Math.ceil(cutRect.bottom - bodyRect.top + 20),
      cutoff: cutoff,
      words: words,
    };
  }

  function syncTocPreview(root, wrap, cutoff, expanded) {
    var nav = root.querySelector('[data-tcb-bf-toc-nav]');
    if (!nav) return;

    var body = wrap.querySelector('[data-tcb-bf-readmore-inner]');
    var blocks = body ? getContentBlocks(body) : [];
    var cutoffIndex = cutoff ? blocks.indexOf(cutoff) : -1;
    var links = nav.querySelectorAll('[data-tcb-bf-toc-link]');
    if (!links.length) return;

    links.forEach(function (link) {
      if (expanded || cutoffIndex < 0) {
        link.classList.remove('is-preview-hidden');
        return;
      }

      var id = (link.getAttribute('href') || '').replace(/^#/, '');
      var heading = id ? document.getElementById(id) : null;
      var headingIndex = -1;

      if (heading) {
        for (var i = 0; i < blocks.length; i++) {
          if (blocks[i] === heading) {
            headingIndex = i;
            break;
          }
        }
      }

      link.classList.toggle('is-preview-hidden', headingIndex < 0 || headingIndex > cutoffIndex);
    });

    root.classList.toggle('is-article-preview', !expanded && cutoffIndex >= 0);
  }

  function applyReadMoreClamp(root, wrap) {
    var body = wrap.querySelector('[data-tcb-bf-readmore-inner]');
    var btn = wrap.querySelector('[data-tcb-bf-readmore-btn]');
    if (!body || !btn) return;

    var targetWords = resolvePreviewWords(wrap);
    var metrics = previewMetrics(body, targetWords);
    var fullHeight = body.scrollHeight;

    if (fullHeight <= metrics.height + 48 || countWords(body.innerText) <= targetWords) {
      btn.hidden = true;
      body.style.maxHeight = '';
      body.style.overflow = '';
      body.classList.remove('is-clamped');
      wrap.classList.remove('is-expanded');
      root.classList.remove('is-article-preview');
      syncTocPreview(root, wrap, null, true);
      return;
    }

    btn.hidden = false;
    if (!wrap.classList.contains('is-expanded')) {
      body.style.maxHeight = metrics.height + 'px';
      body.style.overflow = 'hidden';
      body.classList.add('is-clamped');
      syncTocPreview(root, wrap, metrics.cutoff, false);
    }
  }

  function initReadMore(root) {
    root.querySelectorAll('[data-tcb-bf-readmore]').forEach(function (wrap) {
      if (wrap.getAttribute('data-readmore-init') === '1') return;

      var body = wrap.querySelector('[data-tcb-bf-readmore-inner]');
      var btn = wrap.querySelector('[data-tcb-bf-readmore-btn]');
      if (!body || !btn) return;

      wrap.setAttribute('data-readmore-init', '1');
      wrap.classList.remove('is-expanded');

      applyReadMoreClamp(root, wrap);

      btn.addEventListener('click', function () {
        var expanded = wrap.classList.toggle('is-expanded');
        var targetWords = resolvePreviewWords(wrap);
        var metrics = previewMetrics(body, targetWords);

        body.style.maxHeight = expanded ? 'none' : metrics.height + 'px';
        body.style.overflow = expanded ? '' : 'hidden';
        body.classList.toggle('is-clamped', !expanded);
        btn.textContent = expanded ? 'Show less' : btn.getAttribute('data-label-collapsed') || 'Read full guide';
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        syncTocPreview(root, wrap, metrics.cutoff, expanded);
        root.classList.toggle('is-article-preview', !expanded);
      });

      window.addEventListener(
        'resize',
        debounce(function () {
          if (!wrap.classList.contains('is-expanded')) applyReadMoreClamp(root, wrap);
        }, 150)
      );
    });
  }

  function initToc(root) {
    var nav = root.querySelector('[data-tcb-bf-toc-nav]');
    if (!nav || nav.getAttribute('data-bound') === '1') return;

    var sourceSel = nav.getAttribute('data-tcb-bf-toc-source') || '[data-tcb-bf-readmore-inner]';
    var source = root.querySelector(sourceSel);
    if (!source) source = root.querySelector('.tcb-bf-main, .tcb-pmg-main, .tcb-pbg-main');
    if (!source) return;

    var headings = source.querySelectorAll('h2, h3');
    if (!headings.length) {
      var leftAside = nav.closest('.tcb-bf-aside--left');
      if (leftAside) leftAside.classList.add('is-empty');
      return;
    }

    nav.setAttribute('data-bound', '1');
    var html = '';
    var usedIds = {};

    headings.forEach(function (heading, index) {
      if (!heading.textContent.trim()) return;

      var id = heading.id || slugify(heading.textContent) || 'section-' + index;
      while (usedIds[id]) {
        id = id + '-' + index;
      }
      usedIds[id] = true;
      if (!heading.id) heading.id = id;

      var level = heading.tagName === 'H3' ? ' is-sub' : '';
      html +=
        '<a class="tcb-bf-toc__link' +
        level +
        '" href="#' +
        escapeHtml(id) +
        '" data-tcb-bf-toc-link>' +
        escapeHtml(heading.textContent.trim()) +
        '</a>';
    });

    nav.innerHTML = html;

    var links = nav.querySelectorAll('[data-tcb-bf-toc-link]');
    if (!links.length) return;

    function setActive(id) {
      links.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setActive(entry.target.id);
          });
        },
        { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
      );
      headings.forEach(function (heading) {
        if (heading.id) observer.observe(heading);
      });
    }
  }

  function initUtilities(root) {
    var articleUrl = root.getAttribute('data-article-url') || window.location.href;
    var articleTitle = root.getAttribute('data-article-title') || document.title;
    var storageKey = 'tcb-saved-guide:' + articleUrl;

    root.querySelectorAll('[data-tcb-bf-print]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.print();
      });
    });

    root.querySelectorAll('[data-tcb-bf-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (navigator.share) {
          navigator.share({ title: articleTitle, url: articleUrl }).catch(function () {});
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(articleUrl).then(function () {
            btn.setAttribute('data-copied', '1');
            window.setTimeout(function () {
              btn.removeAttribute('data-copied');
            }, 2000);
          });
        }
      });
    });

    root.querySelectorAll('[data-tcb-bf-save]').forEach(function (btn) {
      function syncSaved() {
        var saved = false;
        try {
          saved = window.localStorage.getItem(storageKey) === '1';
        } catch (e) {}
        btn.classList.toggle('is-saved', saved);
        btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      }

      syncSaved();
      btn.addEventListener('click', function () {
        try {
          var saved = window.localStorage.getItem(storageKey) === '1';
          window.localStorage.setItem(storageKey, saved ? '0' : '1');
        } catch (e) {}
        syncSaved();
      });
    });
  }

  function initWireframe(root) {
    if (!root || root.getAttribute('data-bound') === '1') return;
    root.setAttribute('data-bound', '1');
    initToc(root);
    initReadMore(root);
    initUtilities(root);
  }

  function boot() {
    document.querySelectorAll('[data-tcb-blog-wireframe]').forEach(initWireframe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-tcb-blog-wireframe]');
    if (root) initWireframe(root);
  });
})();
